export default function ESTP(props) {
  return (
    <div className="row">
      <div className="col-12 p-5">
        <article className="main description">
          <h1>شخصیت “کارآفرین”</h1>{" "}
          <blockquote>
            <p>زندگی یا ماجراجویی جسورانه است یا اساساً هیچ.</p>{" "}
            <footer>Helen Keller</footer>
          </blockquote>{" "}
          <p>
            گونه شخصیت کارآفرین همواره بر محیط بلافصل اطراف خود تأثیر دارد -
            بهترین راه برای تشخیص آنها در یک مهمانی است که دارند به&zwnj;سرعت از
            یک گروه به سراغ گروهی دیگر می&zwnj;روند. شخصیت&zwnj;های کارآفرین که
            با طنزی نافذ و زمینی موجبات خنده و سرگرمی را فراهم می&zwnj;کنند عاشق
            این هستند که در مرکز توجه باشند. اگر از یکی از حضار خواسته شود که به
            روی صحنه بیاید، کارآفرینان داوطلب می&zwnj;شوند - یا دوستان خجالتی
            خود را داوطلب می&zwnj;کنند.
          </p>{" "}
          <p>
            نظریه، مفاهیم انتزاعی و بحث&zwnj;های کشدار در مورد مسائل جهانی و
            پیامدهای آن افراد دارای گونه شخصیتی کارآفرین را برای مدت زمان طولانی
            علاقه&zwnj;مند نگه نمی&zwnj;دارد. کارآفرینان گفتگوی خود را پر از
            انرژی و با حجم مناسبی از اطلاعات انجام می&zwnj;دهند، اما دوست دارند
            در مورد چیزهای عینی صحبت کنند - یا از این هم بهتر بیرون بروند و
            انجامش بدهند. کارآفرینان قبل از اینکه نگاه کنند و اشتباهات خود را
            رفع کنند آن را رها می&zwnj;کنند، بجای اینکه بنشینند و به احتمالات و
            روش&zwnj;های فرار فکر کنند.
          </p>{" "}
          <h2>هرگز حرکت را با عمل اشتباه نگیر</h2>{" "}
          <p>
            کارآفرینان محتمل&zwnj;ترین گونه شخصیتی هستند که ممکن است شیوه زندگی
            رفتار مخاطره&zwnj;آمیز را در پیش بگیرند. آن&zwnj;ها در لحظه زندگی
            می&zwnj;کنند و دست به عمل می&zwnj;زنند - آن&zwnj;ها ناحیه&zwnj;ای
            آرام در دل طوفان هستند. افراد دارای گونه شخصیتی کارآفرین از درام،
            شور، و لذت سرخوش می&zwnj;شوند نه به خاطر تحریک عاطفی، بلکه به دلیل
            اینکه برای ذهن منطقی آنها بسیار تحریک&zwnj;کننده است. آن&zwnj;ها
            مجبور به گرفتن تصمیماتی حیاتی بر اساس واقعیت آنی و در روند سریع
            پاسخگویی به محرک&zwnj;های منطقی هستند.
          </p>{" "}
          <p>
            این مسئله باعث می&zwnj;شود مدرسه و سایر محیط&zwnj;های بسیار سازمان
            یافته چالشی برای کارآفرینان باشد. قطعاً دلیلش این نیست که این
            شخصیت&zwnj;ها باهوش نیستند و ممکن است عملکرد خوبی داشته باشند، اما
            رویکرد محدودکننده سخنرانی در آموزش رسمی از یادگیری عملی که
            کارآفرینان از آن لذت می&zwnj;برند بسیار دور است. باید بلوغ زیادی
            داشت تا بتوان این روند را همچون ابزاری لازم برای هدفی دانست، چیزی که
            باعث ایجاد فرصت&zwnj;های هیجان&zwnj;انگیزتری می&zwnj;شود.
          </p>{" "}
          <p>
            همچنین مسئله دیگر که برای افراد دارای گونه شخصیتی کارآفرین
            چالش&zwnj;برانگیز است این است که آنها ترجیح می&zwnj;دهند از
            قطب&zwnj;نمای اخلاقی خودشان استفاده کنند تا شخصی دیگر. قوانین ساخته
            شده&zwnj;اند تا زیر پا گذاشته شوند. این احساسی است که بعضی از معلمان
            دبیرستان یا سرپرستان سازمانی احتمالاً با آن هم&zwnj;عقیده هستند و
            می&zwnj;تواند برای شخصیت کارآفرین شهرتی دست و پا کند. اما اگر
            کارآفرینان مشکل&zwnj;آفرینی را به حداقل برسانند، از انرژی خود
            بهره&zwnj;برداری کرده و تمرکز خود را بر روی مسائل خسته&zwnj;کننده از
            دست ندهند، نیرویی محسوب می&zwnj;شوند که نباید آنها را نادیده گرفت.
          </p>{" "}
          <h2>اکثر مردم خیلی خوب گوش نمی&zwnj;دهند</h2>{" "}
          <p>
            شاید کارآفرینان در بین همه دیدگاه&zwnj;های ادراکی و فیلتر نشده
            گونه&zwnj;ها، مهارت منحصر به فردی در تشخیص تغییرات کوچک را داشته
            باشند. این تغییرات می&zwnj;تواند اعم از تغییر چهره، یک سبک لباس
            جدید، یا تغییر عادت باشد و افراد دارای این گونه شخصیتی به افکار و
            انگیزه&zwnj;های پنهان توجه می&zwnj;کنند در حالی که سایر گونه&zwnj;ها
            باید شانس بیاورند تا اساساً متوجه چنین چیزهایی شوند. کارآفرینان
            بلافاصله از این مشاهدات استفاده می&zwnj;کنند و خواستار تغییر شده و
            سؤال می&zwnj;پرسند، اغلب بدون اینکه اهمیت زیادی به حساسیت افراد
            بدهند. کارآفرینان باید به یاد داشته باشند که همه دوست ندارند اسرار و
            تصمیماتشان برملا شود.
          </p>{" "}
          <blockquote className="no-footer">
            <p>
              گاهی اوقات مشاهده و اقدام آنی کارآفرینان درست همان چیزی است که به
              آن نیاز است، به عنوان مثال در برخی از محیط&zwnj;های شرکتی و
              به&zwnj;خصوص در مواقع اضطراری.
            </p>
          </blockquote>{" "}
          <p>
            اما چنانچه شخصیت&zwnj;های کارآفرین مراقب نباشند، ممکن است در دام
            لحظه گرفتار شوند، مسائل را خیلی جدی بگیرند و افراد حساس&zwnj;تر را
            برنجانند یا فراموش کنند که مراقب سلامت و ایمنی خود باشند. کارآفرینان
            تنها چهار درصد جمعیت را تشکیل می&zwnj;دهند و تعدادشان به اندازه کافی
            هست که رقابت و تنوع را حفظ کنند و آنقدر نیست که باعث مخاطراتی
            نظام&zwnj;مند شوند.
          </p>{" "}
          <p>
            کارآفرینان پر از شور و انرژی هستند و ذهنی منطقی، هرچند گاهی اوقات
            پریشان دارند. افراد با این گونه شخصیتی به دلیل الهام&zwnj;بخش بودن،
            قانع&zwnj;کننده بودن و تنوع&zwnj;طلبی به&zwnj;طور ذاتی رهبران گروه
            هستند و همه را در مسیرهایی کمتر پیموده شده به دنبال خود
            می&zwnj;کشند، و هر جا بروند با خود زندگی و هیجان می&zwnj;برند. قرار
            دادن این کیفیت&zwnj;ها در خدمت هدفی سازنده و باارزش چالش واقعی
            کارآفرینان است.
          </p>
        </article>
      </div>
    </div>
  );
}
